import { Input, Select, LoadingIndicator } from '../common'
import { observer } from 'mobx-react-lite'
import { UsersStore } from '../../store'
import { useText } from '../../texts'
const UserDialog = observer(({ show }) => {
  const close = () => UsersStore.closeDialog()
  const handle = (data) => UsersStore.handleDialog(data)
  const handleField = (key, val) => UsersStore.updateForm(key, val)
  const errors = UsersStore.formError
  const form = UsersStore.activeUser
  const roles = UsersStore.getRoles()
  const isFetch = UsersStore.isFetch
  const isNew = UsersStore.isNew
  const t = useText()
  if (!show) return null

  console.log('role', form.role)

  return (
    <div className="dialog-wrapper">
      <div className="dialog">
        {isFetch && <LoadingIndicator show={true} isBackground={true} />}
        <h3 className="card__title">
          {isNew ? t('add') : t('edit')} {t('user')}
        </h3>

        <Input
          value={form.firstName}
          onChange={(v) => handleField('firstName', v)}
          name="firstName"
          placeholder={t('name')}
          error={errors.firstName}
        />
        <Input
          value={form.lastName}
          onChange={(v) => handleField('lastName', v)}
          name="lastName"
          placeholder={t('surname')}
          error={errors.lastName}
        />
        <Input
          value={form.patronymic}
          onChange={(v) => handleField('patronymic', v)}
          name="patronymic"
          placeholder={t('patronymic')}
        />
        <Input
          value={form.email}
          onChange={(v) => handleField('email', v)}
          name="email"
          readOnly={!isNew}
          placeholder={t('email')}
          error={errors.email}
        />
        <Select
          value={t(form.role.name)}
          onChange={(v) => handleField('role', v)}
          options={roles}
          getOptionLabel={(role) => t(role.name)}
          placeholder={t('role')}
          error={errors.role}
        />

        <div className="sm-text error">{errors.global}</div>

        <div className="card-actions">
          <button className="btn btn-secondary" onClick={close}>
            {t('cancel')}
          </button>
          <button className="btn btn-primary ml-auto" onClick={handle}>
            {t('save')}
          </button>
        </div>
      </div>
    </div>
  )
})

export default UserDialog
